import React, { FunctionComponent } from 'react';
import { PopperProps } from '@material-ui/core/Popper/Popper';
import { Popper } from '@material-ui/core';

const MedPopper: FunctionComponent<PopperProps> = (props: PopperProps) => {
  const p = Object.assign({}, props, {
    placement: 'bottom-start',
  });
  return <Popper {...p} />;
};

export default MedPopper;
